import { ExperimentMap } from 'shared/experiments/interface'

export const NOTECARDS_PDP_FLOW_TEST_EXPERIMENT_NAME = 'note_cards_pdp_vs_dff'

export const experimentVariation: ExperimentMap = {
  [NOTECARDS_PDP_FLOW_TEST_EXPERIMENT_NAME]: {
    Control: 'NoteCardsPDPFlowTestControl',
    Enabled: 'NoteCardsPDPFlowTestEnabled',
  },
}

export const galleryExperiments = Object.keys(experimentVariation)
